export const TABS = {
  DEPLOYED_PROJECTS: 'deployed-projects',
  SCHEDULED_PIPELINES: 'scheduled-pipelines',
  RUN_HISTORY: 'run-history'
};
